import { render, staticRenderFns } from "./SocialLink.vue?vue&type=template&id=d0b533b0&"
import script from "./SocialLink.vue?vue&type=script&lang=js&"
export * from "./SocialLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports